import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBFSSKxArU7VHbWJmCL449sScPp40f7D_s",
  authDomain: "intra-day-algo-trader.firebaseapp.com",
  projectId: "intra-day-algo-trader",
  storageBucket: "intra-day-algo-trader.firebasestorage.app",
  messagingSenderId: "763791299388",
  appId: "1:763791299388:web:3d51bc90ee675b3dbe4439",
  measurementId: "G-8TBCW7SKGQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, googleProvider, db };
